import CSchoolSelect from './CSchoolSelect'
export default CSchoolSelect;